import React, { useEffect, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../api';
import UnidadFichaPanel from '../components/UnidadFichaPanel';

export default function PropietariosPage() {
  const { cid } = useParams();
  const [padron, setPadron] = useState([]);
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');
  const [filtro, setFiltro] = useState('todos');
  const [q, setQ] = useState('');
  const [ficha, setFicha] = useState(null);
  const [showAlta, setShowAlta] = useState(false);
  const [form, setForm] = useState({
    codigoDepto: '',
    nombre: '',
    email: '',
    rut: '',
    telefono: '',
    cuotaMensual: ''
  });
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({});

  const load = () => {
    api
      .get(`/gastos-comunes/condominios/${cid}/padron`)
      .then((r) => setPadron(r.data))
      .catch((e) => setError(e.response?.data?.error || e.message));
  };

  useEffect(() => {
    if (cid) {
      localStorage.setItem('gc_condominio_id', cid);
      load();
    }
  }, [cid]);

  const filtrado = useMemo(() => {
    let rows = padron;
    if (filtro === 'morosos') rows = rows.filter((r) => r.deudaTotal > 0);
    if (filtro === 'aldia') rows = rows.filter((r) => !r.deudaTotal);
    if (filtro === 'sincorreo') rows = rows.filter((r) => r.sinCorreo);
    if (q.trim()) {
      const t = q.trim().toLowerCase();
      rows = rows.filter(
        (r) =>
          String(r.codigoDepto).toLowerCase().includes(t) ||
          (r.titularNombre || '').toLowerCase().includes(t)
      );
    }
    return rows;
  }, [padron, filtro, q]);

  const submitAlta = async (e) => {
    e.preventDefault();
    setError('');
    setMsg('');
    try {
      await api.post(`/gastos-comunes/condominios/${cid}/propietarios`, form);
      setForm({ codigoDepto: '', nombre: '', email: '', rut: '', telefono: '', cuotaMensual: '' });
      setMsg('Propiedad registrada.');
      setShowAlta(false);
      load();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  const startEdit = (row) => {
    const t = row.titulares?.[0];
    if (!t) return;
    setEditId(`${row.id}-${t.personaId}`);
    setEditForm({
      unidadId: row.id,
      personaId: t.personaId,
      codigoDepto: row.codigoDepto,
      nombre: t.nombre,
      email: t.email || '',
      rut: t.rut || '',
      cuotaMensual: row.cuotaMensual ?? ''
    });
    setFicha(null);
  };

  const saveEdit = async () => {
    setError('');
    setMsg('');
    try {
      await api.patch(`/gastos-comunes/condominios/${cid}/propietarios/${editForm.personaId}`, {
        nombre: editForm.nombre,
        email: editForm.email,
        rut: editForm.rut
      });
      await api.patch(`/gastos-comunes/condominios/${cid}/departamentos/${editForm.unidadId}`, {
        codigoDepto: editForm.codigoDepto,
        cuotaMensual: editForm.cuotaMensual === '' ? null : Number(editForm.cuotaMensual)
      });
      setEditId(null);
      setMsg('Datos actualizados.');
      load();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  return (
    <div className="padron-layout">
      <div className="padron-main">
        <div className="page-header">
          <h2>Padrón de propiedades</h2>
          <p>
            Contactos y cuotas de referencia (edición). Cobros por mes, columnas de meses anteriores y pagos están en{' '}
            <Link to={`/c/${cid}/cobranza`}>Ingresos</Link>.
          </p>
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        {msg && <div className="alert alert-success">{msg}</div>}

        <div className="card toolbar-card">
          <div className="form-row">
            <div className="field">
              <label>Buscar</label>
              <input placeholder="Propiedad o nombre" value={q} onChange={(e) => setQ(e.target.value)} />
            </div>
            <div className="field">
              <label>Filtro</label>
              <select value={filtro} onChange={(e) => setFiltro(e.target.value)}>
                <option value="todos">Todos</option>
                <option value="morosos">Con deuda</option>
                <option value="aldia">Al día</option>
                <option value="sincorreo">Sin correo</option>
              </select>
            </div>
            <button type="button" className="btn secondary" onClick={() => setShowAlta(!showAlta)}>
              {showAlta ? 'Ocultar alta' : 'Alta manual'}
            </button>
          </div>
        </div>

        {showAlta && (
          <div className="card">
            <h3 className="card-title">Alta manual</h3>
            <form onSubmit={submitAlta}>
              <div className="form-row">
                <div className="field">
                  <label>Propiedad</label>
                  <input value={form.codigoDepto} onChange={(e) => setForm({ ...form, codigoDepto: e.target.value })} required />
                </div>
                <div className="field">
                  <label>Propietario</label>
                  <input value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} required />
                </div>
                <div className="field">
                  <label>Correo cobro</label>
                  <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
                </div>
                <div className="field">
                  <label>Cuota ref. CLP</label>
                  <input type="number" value={form.cuotaMensual} onChange={(e) => setForm({ ...form, cuotaMensual: e.target.value })} />
                </div>
              </div>
              <button type="submit" className="btn">
                Guardar
              </button>
            </form>
          </div>
        )}

        <div className="card padron-table-card padron-table-simple">
          <table className="data-table padron-simple-table">
            <thead>
              <tr>
                <th>Propiedad</th>
                <th>Propietario</th>
                <th>Correo</th>
                <th aria-label="Acciones" />
              </tr>
            </thead>
            <tbody>
              {filtrado.map((row) => {
                const t = row.titulares?.[0];
                const eid = t ? `${row.id}-${t.personaId}` : null;
                const editing = eid && editId === eid;
                const selected = ficha?.id === row.id;
                if (editing) {
                  return (
                    <tr key={eid} className="row-editing">
                      <td>
                        <input value={editForm.codigoDepto} onChange={(ev) => setEditForm({ ...editForm, codigoDepto: ev.target.value })} />
                      </td>
                      <td>
                        <input value={editForm.nombre} onChange={(ev) => setEditForm({ ...editForm, nombre: ev.target.value })} />
                      </td>
                      <td>
                        <input value={editForm.email} onChange={(ev) => setEditForm({ ...editForm, email: ev.target.value })} />
                      </td>
                      <td>
                        <label className="sr-only">Cuota ref.</label>
                        <input
                          type="number"
                          title="Cuota ref. CLP"
                          placeholder="Cuota ref."
                          value={editForm.cuotaMensual}
                          onChange={(ev) => setEditForm({ ...editForm, cuotaMensual: ev.target.value })}
                        />
                        <button type="button" className="btn secondary" onClick={saveEdit}>
                          OK
                        </button>
                      </td>
                    </tr>
                  );
                }
                return (
                  <tr
                    key={row.id}
                    className={selected ? 'row-selected' : ''}
                    onClick={() => setFicha(row)}
                    style={{ cursor: 'pointer' }}
                  >
                    <td>
                      <strong>{row.codigoDepto}</strong>
                    </td>
                    <td>{row.titularNombre || '—'}</td>
                    <td className={row.sinCorreo ? 'cell-warn' : ''}>{t?.email || '—'}</td>
                    <td onClick={(e) => e.stopPropagation()}>
                      {t && (
                        <button type="button" className="btn secondary" onClick={() => startEdit(row)}>
                          Editar
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {!filtrado.length && <p style={{ color: 'var(--gc-muted)' }}>Sin registros para este filtro.</p>}
        </div>
      </div>
      {ficha && <UnidadFichaPanel row={ficha} onClose={() => setFicha(null)} canEdit />}
    </div>
  );
}
